/* eslint-disable no-unused-vars */
import axios from "axios";
import { ACCESS_TOKEN } from "../utils/constants";

const axiosApi = axios.create({
  baseURL: process.env.REACT_APP_HOST,
});
const accessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI2NTVjZmUwYWY5ZDEzY2ZlMTM2YzFmMGEiLCJpYXQiOjE3MDQyMjg2MTgsImV4cCI6MTczNTc2NDYxOCwidHlwZSI6ImFjY2VzcyIsInJvbGUiOiJ1c2VyIn0.YIFwzz_X5qZ_CTqqmdZyDN5_crpSqxTZLC2woeFniUo';
axiosApi.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    // const statusCode = error?.response?.status;

    // if (statusCode === 401) {
    //   window.location.href = "/login";
    // }

    return Promise.reject(error);
  }
);

export { axiosApi };

// import axios from "axios";

// // export const baseURL = "https://portal.mybubbleapp.co.uk/api/";
// // export const baseURL = "http://3.142.235.73:4040/api/";
// export const baseURL = "http://18.116.123.138:4040/api/";

// const accessToken = localStorage.getItem("accessToken");
// axios.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;

// export default axios.create({
//   baseURL,

//   // add additional headers
// });
